import * as React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { DiagnosisReadDTO } from '../../generated/api-client';
import { isDiagnosisClosed } from '../../utils/diagnosisStatus';

interface Props {
  diagnoses: DiagnosisReadDTO[];
  currentUserId?: string;
}

export const HomeDiagnosisSummaryCard: React.FC<Props> = ({ diagnoses, currentUserId }) => {
  const open = diagnoses.filter(d => !isDiagnosisClosed(d));
  const closed = diagnoses.filter(d => isDiagnosisClosed(d));

  const countResp1 = (items: DiagnosisReadDTO[]) =>
    items.filter(d => currentUserId && d.responsible_01 === currentUserId).length;

  const rows = [
    { label: 'Aperte', assigned: open.length, resp1: countResp1(open) },
    { label: 'Chiuse', assigned: closed.length, resp1: countResp1(closed) },
    { label: 'Totale', assigned: diagnoses.length, resp1: countResp1(diagnoses) },
  ];

  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, height: '100%' }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Riepilogo diagnosi
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="right">Diagnosi assegnate</TableCell>
              <TableCell align="right">Di cui Responsabile 1</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.label}>
                <TableCell>{row.label}</TableCell>
                <TableCell align="right">{row.assigned}</TableCell>
                <TableCell align="right">{row.resp1}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

